/* tslint:disable */
/* eslint-disable */
export enum AdditionalAmountType {
  Surcharge = 'Surcharge',
  ServiceFee = 'ServiceFee'
}
